<template>
    <div>
        <b-card-text>
            <div v-html="text"></div>
        </b-card-text>
        <Dropzone
            v-if="url"
            :url="url"
            :maxFiles="50"
            @success="vdropzone_success_handler"
            :acceptedFiles="'image/jpeg,image/png,image/gif,image/bmp,image/tiff,application/pdf'"
        />
    </div>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['url', 'text'],
        methods: {
            vdropzone_success_handler(file, response) {
                this.$emit('documentosSubidos', response);
            }
        },
        components: {
            Dropzone,
        }
    }
</script>